/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsPathParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsQueryParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons400,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons500,
} from "../../types/individualPaymentEditorsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons.ts";

function getPostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsUrl(
  financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsPathParams["financialPersonId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}/coupons` as const,
  };
  return res;
}

/**
 * @description Cria o vínculo ativo do código do cupom e soma o desconto no plano (percentual ou valor). Falha quando já existe cupom aplicado, cupom sem código ou plano/cupom inexistente. Migrado do legado IndividualPayment/AddCoupon. **(Requer Authorization para autenticação)**
 * @summary Aplica um cupom ao plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/coupons}
 */
export async function postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons(
  financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsPathParams["financialPersonId"],
  params?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons400
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsUrl(
      financialPersonId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
